import {
  APPLICATIONS_ID,
  APPLICATIONS_NAME,
  LOAD_APP_AS_KEY,
  LOAD_APP_AS_KEY_INITIAL,
} from "@next-platform/client-common-core/infra/constants/domains";
import getEnumValue from "@next-platform/client-common-core/infra/utils/getEnumValue";

export function loadAsApplication(appName: string | undefined, initialLoad: boolean = false) {
  const applicationName: APPLICATIONS_NAME | undefined = getEnumValue(APPLICATIONS_NAME, appName, true);
  if (applicationName === undefined) {
    throw Error("Unknown application: " + appName + ", Unable to determine application.");
  }

  if (initialLoad) {
    localStorage.setItem(LOAD_APP_AS_KEY_INITIAL, applicationName);
  } else {
    localStorage.setItem(LOAD_APP_AS_KEY, applicationName);
  }
}

export function reset3rdPartiesLocalSettings() {
  localStorage.clear();
  localStorage.setItem(LOAD_APP_AS_KEY_INITIAL, APPLICATIONS_ID.SpicyChat);
  localStorage.setItem(LOAD_APP_AS_KEY, APPLICATIONS_ID.SpicyChat);
}
